import { Permission } from '@today/types'

/** Which product-admin controls the viewer may see (TO-416 product-admin-ui REQ-001). */
export interface ProductCapabilities {
	read: boolean
	write: boolean
	delete: boolean
	/** Upload/remove the product image: needs `product.write` and `file.write`. */
	uploadImage: boolean
	/** Thumbnails and previews: needs `file.read`. */
	viewImages: boolean
	manageLocales: boolean
}

/** The pure permission map: a control the viewer lacks is not rendered. */
export const productCapabilities = (permissions: readonly string[]): ProductCapabilities => {
	const has = (permission: Permission) => permissions.includes(permission)
	return {
		read: has(Permission.PRODUCT_READ),
		write: has(Permission.PRODUCT_WRITE),
		delete: has(Permission.PRODUCT_DELETE),
		uploadImage: has(Permission.PRODUCT_WRITE) && has(Permission.FILE_WRITE),
		viewImages: has(Permission.FILE_READ),
		manageLocales: has(Permission.TENANT_MANAGE_SETTINGS),
	}
}
